"use client";

import React, { useCallback, useEffect, useState } from "react";
import { format } from 'date-fns';
import { useDebounce } from "@uidotdev/usehooks";
import { Col } from "react-bootstrap";
import MeTab from "../components/tabs/meTab";
import { PlanScreenContext, TaskModalProps } from "../components/plan/context";
import { useTaskModal } from "../components/TaskModalContext";
import { useData } from "../storage/accessors";


export default function Home() {
    const taskModalContext = useTaskModal();
    const setTaskModal = taskModalContext?.setTaskModal;
    const { plans, tasks, wheels, roles } = useData();
    const [justDonePlans, setJustDonePlans] = useState<string[]>([]);
    const debounced = useDebounce(justDonePlans, 5000);

    const wheel = wheels.objects['wheel'];
    const currentLifePartUuid = wheel?.currentLifePart;
    const hasCurrentLifePart = currentLifePartUuid ? !!roles.objects[currentLifePartUuid] : false;

    const handleOpenTask = useCallback((props: TaskModalProps) => {
        if (setTaskModal) {
            setTaskModal(props);
        }
    }, [setTaskModal]);

    const planJustDone = useCallback((uuid: string) => {
        setJustDonePlans(old => [...old, uuid]);
    }, []);

    const movePlan = useCallback((planUUID: string, newDate: string) => {
        plans.save(planUUID, { date: newDate });
    }, [plans]);

    const copyPlan = useCallback((planUUID: string, newDate: string) => {
        const currentPlan = Object.values(plans.objects).find(p => p.uuid === planUUID);
        if (!currentPlan) return;

        const task = tasks.objects[currentPlan.task];
        if (!task) return;

        const newPlan = {
            uuid: crypto.randomUUID(),
            isDone: false,
            task: task.uuid,
            date: newDate,
            ordering: currentPlan.ordering,
            needTime: currentPlan.needTime || "00:00",
            isImportant: currentPlan.isImportant,
            isGoal: currentPlan.isGoal,
            startTime: currentPlan.startTime,
            endTime: currentPlan.endTime,
            createdAt: format(new Date(), 'yyyy-MM-dd'),
        };
        plans.create(newPlan);
    }, [plans, tasks]);

    useEffect(() => {
        if (debounced.length > 0) {
            setJustDonePlans([]);
        }
    }, [debounced]);

    return (
        <PlanScreenContext.Provider value={{
            filterPart: '',
            searchTerm: '',
            hideDone: true,
            showOld: false,
            justDonePlans,
            planJustDone,
            setTaskModal: handleOpenTask,
            movePlan,
            copyPlan
        }}>
            <Col lg={{ span: 8, offset: 2 }}>
                <MeTab />
            </Col>
        </PlanScreenContext.Provider>
    );
}
